import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { FilterComponentProp } from '../hocs/types'
import { SearchFiltersCheckboxes } from '../../components/search-filters-checkbox/search-filters-checkboxes'

const accelerationProps: FilterComponentProp = {
    title: 'Acceleration',
}

export const Acceleration = withFacetContext(
    FacetName.acceleration_values,
    withFilterContext(FilterName.acceleration_values, SearchFiltersCheckboxes, accelerationProps)
)
